<div class="burger-menu" (click)="toggleBurgerMenu($event)" [ngClass]="{'burger-menu-toggled': state}">
    <div class="label-container">
        <div class="label" translate="BURGER_MENU_LABEL"></div>
        <i class="icon-smash_close close"></i>
    </div>
</div>

<div class="burger-menu-container" [ngClass]="{'burger-menu-container-toggled': state}">
    <div class="burger-menu-modal">
        <ul class="burger-menu-main-link-list">
            <ng-container *ngIf="isMainDomain && !isLoggedIn">
                <li class=" burger-menu-main-link-list-item">
                    <a id="burger-menu-link-discover-smash" href="{{ 'BURGER_MENU_LINK_URL_SMASH_FOR_EVERYONE' | translate }}">{{
                        'BURGER_MENU_LINK_LABEL_SMASH_FOR_EVERYONE' | translate }}</a>
                </li>
            </ng-container>
            <ng-container *ngIf="isMainDomain && !isLoggedIn">
                <li class="burger-menu-main-link-list-item">
                    <a id="burger-menu-link-advertising" rel="nofollow" href="{{ 'BURGER_MENU_LINK_URL_SMASH_PRO' | translate }}">{{
                        'BURGER_MENU_LINK_LABEL_SMASH_PRO' | translate}}</a>
                </li>
            </ng-container>
            <ng-container *ngIf="isMainDomain && !isLoggedIn">
                <li class="burger-menu-main-link-list-item">
                    <a id="burger-menu-link-advertising" rel="nofollow" href="{{ 'BURGER_MENU_LINK_URL_SMASH_TEAM' | translate }}">{{
                        'BURGER_MENU_LINK_LABEL_SMASH_TEAM' | translate}}</a>
                </li>
            </ng-container>
            <ng-container *ngIf="isMainDomain && !isLoggedIn">
                <li class="burger-menu-main-link-list-item">
                    <a id="burger-menu-link-advertising" rel="nofollow"
                        href="{{ 'BURGER_MENU_LINK_URL_SMASH_ENTERPRISE' | translate }}">{{
                        'BURGER_MENU_LINK_LABEL_SMASH_ENTERPRISE' | translate}}</a>
                </li>
            </ng-container>
            <ng-container *ngIf="isMainDomain && !isLoggedIn">
                <li class="burger-menu-main-link-list-item">
                    <a id="burger-menu-link-pricing" rel="nofollow" href="{{ 'BURGER_MENU_LINK_URL_PRICING' | translate }}">{{
                        'BURGER_MENU_LINK_LABEL_PRICING' | translate
                        }}</a>
                </li>
            </ng-container>
            <ng-container *ngIf="isMainDomain && !isLoggedIn">
                <li class="burger-menu-main-link-list-item">
                    <a id="burger-menu-link-api" href="{{ 'BURGER_MENU_LINK_URL_DEVELOPER' | translate }}">{{
                        'BURGER_MENU_LINK_LABEL_DEVELOPER' | translate}}</a>
                </li>
            </ng-container>
            <ng-container *ngIf="!isLoggedIn">
                <li class="burger-menu-main-link-list-item" (click)="redirectToSignin()">
                    <a id="burger-menu-link-signin">{{ 'BURGER_MENU_LINK_LABEL_SIGNIN' |
                        translate }}</a>
                </li>
            </ng-container>

            <ng-container *ngIf="isLoggedIn ">
                <li class="burger-menu-main-link-list-item">
                    <a id="burger-menu-link-my-account" [routerLink]="['/account/team/' + selectedTeam?.id + '/transfers/sent']">{{ 'BURGER_MENU_LINK_LABEL_ACCOUNT' | translate }}</a>
                </li>
            </ng-container>
            <ng-container *ngIf="isLoggedIn">
                <li class="burger-menu-main-link-list-item">
                    <a id="burger-menu-link-signout" [routerLink]="['/signout']">{{ 'BURGER_MENU_LINK_LABEL_SIGNOUT' | translate }}</a>
                </li>
            </ng-container>
            <ng-container *ngIf="isLoggedIn">
                <li class="burger-menu-main-link-list-item">
                    <a target="_blank" id="burger-menu-link-help" href="{{ 'BURGER_MENU_LINK_URL_HELP' | translate }}">{{
                        'BURGER_MENU_LINK_LABEL_HELP' | translate}}</a>
                </li>
            </ng-container>

        </ul>

        <ul class="burger-menu-additional-link-list">
            <ng-container *ngIf="!isLoggedIn && isMainDomain">
                <li class="burger-menu-additional-link-list-item">
                    <a id="burger-menu-link-about" href="{{ 'BURGER_MENU_ADDITIONAL_LINK_URL_ABOUT' | translate }}">{{
                        'BURGER_MENU_ADDITIONAL_LINK_LABEL_ABOUT' | translate }}</a>
                </li>
                <li class="burger-menu-additional-link-list-item">
                    <a id="burger-menu-link-customers" href="{{ 'BURGER_MENU_ADDITIONAL_LINK_URL_CUSTOMERS' | translate }}">{{
                        'BURGER_MENU_ADDITIONAL_LINK_LABEL_CUSTOMERS' | translate }}</a>
                </li>
                <li class="burger-menu-additional-link-list-item">
                    <a id="burger-menu-link-advertising" rel="nofollow" href="{{ 'BURGER_MENU_ADDITIONAL_LINK_URL_ADVERTISING' | translate }}">{{
                        'BURGER_MENU_ADDITIONAL_LINK_ADVERTISING' | translate }}</a>
                </li>
                <li class="burger-menu-additional-link-list-item">
                    <a id="burger-menu-link-security" href="{{ 'BURGER_MENU_ADDITIONAL_LINK_URL_SECURITY' | translate }}">{{
                        'BURGER_MENU_ADDITIONAL_LINK_LABEL_SECURITY' | translate }}</a>
                </li>
                <li class="burger-menu-additional-link-list-item">
                    <a id="burger-menu-link-confidentiality" href="{{ 'BURGER_MENU_ADDITIONAL_LINK_URL_CONFIDENTIALITY' | translate }}">{{
                        'BURGER_MENU_ADDITIONAL_LINK_LABEL_CONFIDENTIALITY' | translate }}</a>
                </li>
                <li class="burger-menu-additional-link-list-item">
                    <a id="burger-menu-link-cookies"(click)="openCookiePreference($event)">{{
                        'BURGER_MENU_ADDITIONAL_LINK_LABEL_COOKIES' | translate }}</a>
                </li>
                <li class="burger-menu-additional-link-list-item">
                    <a id="burger-menu-link-smash-vs-wetransfer" href="{{ 'BURGER_MENU_ADDITIONAL_LINK_URL_SMASH_VS_WETRANSFER' | translate }}">{{
                        'BURGER_MENU_ADDITIONAL_LINK_LABEL_SMASH_VS_WETRANSFER' | translate }}</a>
                </li>
                <li class="burger-menu-additional-link-list-item">
                    <a id="burger-menu-link-terms-of-use" href="{{ 'BURGER_MENU_ADDITIONAL_LINK_URL_TERMS_OF_USE' | translate }}">{{
                        'BURGER_MENU_ADDITIONAL_LINK_LABEL_TERMS_OF_USE' | translate }}</a>
                </li>
                <li class="burger-menu-additional-link-list-item">
                    <a id="burger-menu-link-legal" href="{{ 'BURGER_MENU_ADDITIONAL_LINK_URL_LEGAL' | translate }}">{{
                        'BURGER_MENU_ADDITIONAL_LINK_LABEL_LEGAL' | translate }}</a>
                </li>
                <li class="burger-menu-additional-link-list-item">
                    <a id="burger-menu-link-help" href="{{ 'BURGER_MENU_ADDITIONAL_LINK_URL_HELP' | translate }}">{{
                        'BURGER_MENU_ADDITIONAL_LINK_LABEL_HELP' | translate }}</a>
                </li>
            </ng-container>
            <ng-container *ngIf="isLoggedIn || !isMainDomain">
                <li class="burger-menu-additional-link-list-item">
                    <a id="burger-menu-link-security" href="{{ 'BURGER_MENU_ADDITIONAL_LINK_URL_SECURITY' | translate }}">{{
                        'BURGER_MENU_ADDITIONAL_LINK_LABEL_SECURITY' | translate }}</a>
                </li>
                <li class="burger-menu-additional-link-list-item">
                    <a id="burger-menu-link-confidentiality" href="{{ 'BURGER_MENU_ADDITIONAL_LINK_URL_CONFIDENTIALITY' | translate }}">{{
                        'BURGER_MENU_ADDITIONAL_LINK_LABEL_CONFIDENTIALITY' | translate }}</a>
                </li>
                <li class="burger-menu-additional-link-list-item">
                    <a id="burger-menu-link-cookies" (click)="openCookiePreference($event)">{{
                        'BURGER_MENU_ADDITIONAL_LINK_LABEL_COOKIES' | translate }}</a>
                </li>
                <li class="burger-menu-additional-link-list-item">
                    <a id="burger-menu-link-term-of-use" href="{{ 'BURGER_MENU_ADDITIONAL_LINK_URL_TERMS_OF_USE' | translate }}">{{
                        'BURGER_MENU_ADDITIONAL_LINK_LABEL_TERMS_OF_USE' | translate }}</a>
                </li>
                <li class="burger-menu-additional-link-list-item">
                    <a id="burger-menu-link-legal" href="{{ 'BURGER_MENU_ADDITIONAL_LINK_URL_LEGAL' | translate }}">{{
                        'BURGER_MENU_ADDITIONAL_LINK_LABEL_LEGAL' | translate }}</a>
                </li>
            </ng-container>
        </ul>
        <div class="burger-footer">
            <div class="select-lang-container">
                <app-smash-select-lang [headerLocation]="headerLocation" withBorder="true"></app-smash-select-lang>
            </div>
            <div class="version">{{'VERSION' | translate }} : {{version}}</div>
        </div>
    </div>
</div>
<div class="overlay-menu" *ngIf="state"></div>